import { PostOrPage } from '@tryghost/content-api'
import { IImage } from '@utils/contentful/contentfulImage'
import { IContentfulConfigurableCard } from 'everest/component/StickySideSlider'
import { TCtaButtonColor } from 'types/contentful/featuresList'
import { BaseTemplate } from 'types/templates'
import { IConfigurableFeature } from '../ConfigurableFeatures/features.types'
import { IConfigurableText } from '../ConfigurableText/ConfigurableText.types'
import {
  TConfigurableTitleSize,
  TConfigurableColor,
} from '../contentfulPage.types'
import { TCategory } from './CategoryCollection'
import { TProductTileData } from 'app/(main)/(catalog)/category/[slug]/_components/ProductTile/ProductTile.types'

export type TConfigurableListVariant =
  | 'you may also like section'
  | 'infinite scroll marquee'
  | 'multi tab features list'
  | 'features collection'
  | 'category collection'
  | 'the wrap posts'
  | 'features grid'
  | 'tile list'

export const LIST_VARIANTS: Record<string, TConfigurableListVariant> = {
  TILE_LIST: 'tile list',
  THE_WRAP_POSTS: 'the wrap posts',
  FEATURES_GRID: 'features grid',
  CATEGORY_COLLECTION: 'category collection',
  FEATURES_COLLECTION: 'features collection',
  PRODUCTS_SUGGESTIONS: 'you may also like section',
  MULTI_TAB_FEATURES_LIST: 'multi tab features list',
  INFINITE_SCROLL_MARQUEUE: 'infinite scroll marquee',
}

export interface IMinimalisticFeature {
  title: string
  description: string
  image: IImage
}
export interface IConfigurableList {
  id: string
  componentKey: 'featuresList'
  submenuLabel: string
  backgroundColor: string
  branding: 'old' | 'new'
  title: string
  markdownTitle?: string
  titleConfig?: IConfigurableText
  titleSize?: TConfigurableTitleSize
  titleColor?: TConfigurableColor
  textAlign?: 'left' | 'center' | 'right'
  subtitle?: string
  subtitleColor?: string
  description?: string
  ctaLabel?: string
  ctaLink?: string
  ctaButtonType?: string
  ctaButtonColor?: TCtaButtonColor
  ctaEventId: string
  topImage?: IImage
  features?:
    | IConfigurableFeature[]
    | IContentfulConfigurableCard[]
    | IMinimalisticFeature[]
  productTemplates?: BaseTemplate[]
  wrapBlogPosts?: Partial<PostOrPage>[]
  suggestedProducts: TProductTileData[]
  categoryCollection: TCategory[]
  listVariant: TConfigurableListVariant
  onCtaAction?: ({ ctaId }) => void
  trackingIdentifier: string
  generateStatically?: boolean
  nestedLists?: IConfigurableList[]
}
